import { settleScatsGame } from './ggPlayScats.js'

// Scats add-on results (frame plug-in). Settles the pot ONCE at the end from the
// entered scorecard, over the opted-in players only. Rendered alongside the main
// game's results.
const cell = { border: '1px solid #ddd', padding: '6px 10px', fontSize: 16 }
const money = (v) => (v >= 0 ? `+$${v}` : `−$${Math.abs(v)}`)

export default function GScatsResults({ game }) {
  const scats = game?.meta?.addons?.scats
  if (!scats?.enabled) return null
  const course = game.meta.course || {}
  const r = settleScatsGame(game.players || [], game.scores || {}, course.pars || [], {
    buyIn: scats.buyIn, useHandicap: scats.useHandicap, mode: scats.mode, strokeIndex: course.strokeIndex, optedIn: scats.optedIn,
  })

  return (
    <div className="mt-4">
      <div className="text-xs font-bold uppercase tracking-wide text-gray-500 mb-1">💰 Scats — side pot</div>
      <p className="text-sm text-gray-500 mb-2">${r.buyIn} buy-in × {r.playerCount} in = <b>${r.pot}</b> pot · split by birdies-or-better{scats.useHandicap ? ` (net · ${scats.mode})` : ''}{r.totalScats === 0 ? ' · no scats → buy-ins returned' : ''}.</p>
      <table className="w-full text-base" style={{ borderCollapse: 'collapse' }}>
        <thead><tr style={{ background: '#f6f6f2', color: '#555' }}>{['Player', 'Scats', 'Share', 'Net'].map((h) => <th key={h} style={{ ...cell, textAlign: 'left' }}>{h}</th>)}</tr></thead>
        <tbody>{r.rows.map((x) => (
          <tr key={x.id}>
            <td style={cell}>{x.name}</td><td style={cell}>{x.scats}</td><td style={cell}>${x.share}</td>
            <td style={cell}><b style={{ color: x.net > 0 ? '#1B7A3E' : x.net < 0 ? '#B42318' : '#374151' }}>{money(x.net)}</b></td>
          </tr>
        ))}</tbody>
      </table>
    </div>
  )
}
